import * as actions from './ReportFiltersActionsType';
import ReportFiltersService from './ReportFiltersService';

const set = (type, payload) => dispatcher => dispatcher({type, payload});

export const setTerminals = terminals => set(actions.SET_TERMINALS, terminals);
export const setChips = chips => set(actions.SET_CHIP, chips);
export const setDates = (startTime, endTime) => set(actions.SET_DATE, {startTime, endTime});
export const clearHidableFilters = () => set(actions.CLEAR_HIDEABLE);
export const setReportType = ({reportSelected = {}}) => set(actions.SET_REPORT, reportSelected.key);

export const loadTerminals = () => async dispatcher => {
  dispatcher({type: actions.TERMINALS_REQUEST});
  try {
    const payload = await ReportFiltersService.loadTerminals();
    dispatcher({type: actions.TERMINALS_SUCCESS, payload});
  } catch (e) {
    console.error(e);
    dispatcher({type: actions.TERMINALS_FAILURE});
  }
};

export const predict = text => async dispatcher => {
  dispatcher({type: actions.SEARCH_REQUEST});
  try {
    const payload = await ReportFiltersService.predict(text);
    dispatcher({type: actions.SEARCH_SUCCESS, payload});
  } catch (e) {
    console.error(e);
    dispatcher({type: actions.SEARCH_FAILURE});
  }
};

export const clear = () => dispatcher => dispatcher({type: actions.CLEAR});
